import React from 'react';
import { Zap, Shield, Clock } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function BenefitsSection() {
  const {
    ref,
    isRevealed
  } = useScrollReveal();
  const benefits = [{
    icon: <Zap className="h-8 w-8 text-[#c9a84c]" data-id="element-18" />,
    title: 'AI-Powered Speed',
    description: 'Built with cutting-edge AI technology for lightning-fast performance and instant loading times.'
  }, {
    icon: <Shield className="h-8 w-8 text-[#c9a84c]" data-id="element-19" />,
    title: 'Professional Quality',
    description: 'Premium design aesthetics that rival agencies charging 10x the price. Polished to perfection.'
  }, {
    icon: <Clock className="h-8 w-8 text-[#c9a84c]" data-id="element-20" />,
    title: '48-Hour Delivery',
    description: 'From concept to launch in just two days. We value your time and deliver excellence quickly.'
  }];
  return <section id="benefits" className="py-24 md:py-32 relative" data-id="element-21">
      {/* Background Glow */}
      <div className="absolute top-1/2 right-0 -translate-y-1/2 w-[600px] h-[600px] bg-[radial-gradient(circle,rgba(201,168,76,0.08)_0%,transparent_70%)] pointer-events-none z-0" data-id="element-22" />

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-23">
        <div ref={ref} className={`text-center mb-16 transition-all duration-1000 ${isRevealed ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-24">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-25">
            Why Choose <span className="text-[#c9a84c]" data-id="element-26">AI.WEB</span>?
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-27">
            We combine human creativity with artificial intelligence to deliver
            superior results.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-28">
          {benefits.map((benefit, index) => <BenefitCard key={index} benefit={benefit} delay={index * 200} data-id="element-29" />)}
        </div>
      </div>
    </section>;
}
function BenefitCard({
  benefit,
  delay
}: {
  benefit: any;
  delay: number;
}) {
  const {
    ref,
    isRevealed
  } = useScrollReveal();
  return <div ref={ref} style={{
    transitionDelay: `${delay}ms`
  }} className={`group relative bg-[#0a0a0a] p-8 rounded-lg border-t-2 border-[#c9a84c] hover:border-[#c9a84c] transition-all duration-500 transform ${isRevealed ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'} hover:-translate-y-2 hover:shadow-[0_10px_40px_-10px_rgba(201,168,76,0.15)]`} data-id="element-30">
      <div className="mb-6 p-3 inline-block bg-[#c9a84c]/10 rounded-lg group-hover:bg-[#c9a84c]/20 transition-colors" data-id="element-31">
        {benefit.icon}
      </div>
      <h3 className="text-xl font-bold text-white mb-4 group-hover:text-[#c9a84c] transition-colors" data-id="element-32">
        {benefit.title}
      </h3>
      <p className="text-gray-400 leading-relaxed" data-id="element-33">{benefit.description}</p>
    </div>;
}